module.exports = __webpack_public_path__ + "img/degreeLineRedIcon.08241afb.png";